import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "certificates pt-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-long-arrow-left mr-2" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Danh sách chứng chỉ ")
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = { class: "certificates_content shadow-sm" }
const _hoisted_6 = { class: "content-header p-2" }
const _hoisted_7 = {
  key: 0,
  class: "content-body px-2"
}
const _hoisted_8 = { class: "content-body__item" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "key" }, "Ngày bắt đầu", -1)
const _hoisted_10 = { class: "value" }
const _hoisted_11 = { class: "content-body__item" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "key" }, "Ngày kết thúc", -1)
const _hoisted_13 = { class: "value" }
const _hoisted_14 = { class: "content-body__item__2" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "key" }, "Mô tả", -1)
const _hoisted_16 = { class: "value" }
const _hoisted_17 = { class: "content-body__item__2" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "key" }, "Hình ảnh", -1)
const _hoisted_19 = {
  key: 0,
  class: "list-image"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Avatar3 = _resolveComponent("Avatar3")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.back && _ctx.back(...args))),
      class: "back-link w-100 mb-2 pl-3"
    }, _hoisted_4),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.certificat?.title), 1),
      (_ctx.certificat)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.format(new Date(_ctx.certificat?.effectiveDate), 'dd/MM/yyyy')), 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.format(new Date(_ctx.certificat?.expiredDate), 'dd/MM/yyyy')), 1)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.certificat?.description), 1)
            ]),
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              (_ctx.certificat?.listImages.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.certificat?.listImages, (img, index) => {
                      return (_openBlock(), _createBlock(_component_Avatar3, {
                        width: "80px",
                        height: "80px",
                        radius: "5px",
                        class: "mr-2",
                        key: index,
                        avatar: img,
                        onClick: ($event: any) => (_ctx.handleViewFull(img))
                      }, null, 8, ["avatar", "onClick"]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}